import { useEffect } from 'react';
import { useUserSettingsStore } from '@/hooks/data/settings/useUserSettingsStore';

/**
 * Mirrors `thumbnailSize` onto the `--thumbnail-size` custom property, which the
 * gallery grid sizes its tiles from. This is the one side effect `persist` cannot
 * absorb — it writes to the document, not to storage — and it is the only thing
 * the deleted UserSettingsProvider did besides holding state.
 *
 * Called once from the App component body in `pages/_app.tsx`, which covers both
 * the public and authenticated branches without reintroducing a provider.
 */
export const useThumbnailSizeCssVar = () => {
  const thumbnailSize = useUserSettingsStore((state) => state.thumbnailSize);

  useEffect(() => {
    document.documentElement.style.setProperty('--thumbnail-size', `${thumbnailSize}px`);
  }, [thumbnailSize]);
};

/**
 * Renders nothing, so mounting it as a sibling (rather than calling the hook in `App` itself)
 * keeps a zoom change from re-rendering the whole app tree — there is nothing here to re-render.
 */
export const ThumbnailSizeCssVar = () => {
  useThumbnailSizeCssVar();
  return null;
};
